import React from "react";

export const NoPermissionWindow = () => {
  return (
    <table style={{justifyContent: "center", display: "flex", padding: "30px"}}>
      <tr>
        <td>
          <i className="fa fa-hand-paper-o"></i>
          You don´t have permissions to access this feature
        </td>
      </tr>
    </table>
  );
};
